import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, Container, Image, Spinner, Table, Row, Col, Card } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { isLoggin } from '../service/LoginService';
import RegistOrLogin from './RegistOrLogin';
import DynamicDialog from './DynamicDialog';
import UserMark from './UserMark';
import PlanConfirmDialog from './common/PlanConfirmDialog';
import MuiButton from '@mui/material/Button';
import { LoginInfo } from '../App';
import { Chip } from '@mui/material';

const Legal = () => {
	async function getTerms(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/messages/terms").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
	async function checkout(plan){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/checkout/subscribe/"+plan).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getOfficialPlan(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/official/")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [checkoutProcess,setCheckoutProcess] = useState(false)
    const [showDialog,setShowDialog] = useState(false)
    const [title,setTitle] = useState("")
    const [message,setMessage] = useState("")
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // サブスク契約情報
    const [officialPlan, setOfficialPlan] = useState([])

    function dialog(title,message){
        setTitle(title)
        setMessage(message)
        setShowDialog(true)
    }

	useEffect(() => {
		document.querySelector("title").textContent = "料金プラン - ourt AI"
	},[location.pathname])

    useEffect(() => {
        getOfficialPlan().then(r => {
            if(r.result){
                setOfficialPlan(r.data)
            } else {
                setOfficialPlan([])
            }
        })
    },[])

    function checkoutProcessHandler(plan){
        setCheckoutProcess(true)
        isLoggin().then(r => {
            if(r.result){
                checkout(plan).then(r => {
                    if(r.result){
                        window.location.href = r.data.url
                    } else {
                        dialog("",r.errors)
                        setCheckoutProcess(false)
                    }
                })
            } else {
                dialog(t("common.loginToContinue"),<RegistOrLogin />)
                setCheckoutProcess(false)
            }
        })
    }

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Header />
        <Category />
        <Dialog show={showDialog} title="" message={message} handleClose={() => setShowDialog(false)} />
        <Container>
            {/* ヘッダーセクション */}
            <div className="text-center mb-5">
                <h1 className="mb-3" style={{fontSize:"32px", fontWeight:"bold"}}>
                    料金プラン/運営への支援
                </h1>
                <p className="lead" style={{fontSize:"18px", color:"#666"}}>
                    いつもご利用ありがとうございます。<br />
                    みなさんの支援によって、サービスを維持することができています。
                </p>
            </div>

            {/* プレミアムプランセクション */}
            <Row className="mb-5 justify-content-center">
                <Col lg={4} md={6} className="mb-4">
                    <Card className="h-100 border-2" style={{borderColor:"#ddd"}}>
                        <Card.Body className="d-flex flex-column">
                            <div className="text-center mb-3">
                                <h4 className="fw-bold">Standard スタンダード</h4>
                                <UserMark plan="certification" dialog={() => false} />
                            </div>
                            <div className="text-center mb-4">
                                <div className="h2 fw-bold text-primary">$10</div>
                                <small className="text-muted">1か月ごと</small>
                                <div className="h3 fw-bold mt-2">1,400円</div>
                                <small className="text-muted">1か月ごと</small>
                            </div>
                            <div className="mb-3">
                                <Button 
                                    className="w-100 mb-2" 
                                    variant="primary"
                                    onClick={() => checkoutProcessHandler("standard_dollar")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する ($10)
                                </Button>
                                <Button 
                                    className="w-100" 
                                    variant="outline-primary"
                                    onClick={() => checkoutProcessHandler("standard_yen")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する (1,400円)
                                </Button>
                            </div>
                            <PlanConfirmDialog data={{
                                "item_id":"8db00aac-09a0-11ef-9428-0242ac130002",
                                "subscription_id": loginInfo.plan === "certification" ? officialPlan.subscription_id : "",
                                "name":"スタンダード",
                                "user_name":"アワートAI公式",
                                "amount":1400,
                                "status": loginInfo.plan === "certification" ? "ACTIVE" : "",
                                "official":true
                            }} />
                            <div className="mt-auto">
                                <h6 className="fw-bold mb-2">以下のサービスが含まれます</h6>
                                <ul className="list-unstyled small">
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 広告非表示</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 黄色認証マークの表示(要SMS認証)</li>
                                    <li className="mt-2 fw-bold text-muted">画像生成</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 生成回数が最大100枚/直近1日 ※1</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 生成画像のロゴ削除</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 優先して生成</li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={4} md={6} className="mb-4">
                    <Card className="h-100 border-3 border-warning position-relative">
                        <div className="position-absolute top-0 start-50 translate-middle">
                            <Chip label="オススメ" color='warning' />
                        </div>
                        <Card.Body className="d-flex flex-column pt-4">
                            <div className="text-center mb-3">
                                <h4 className="fw-bold">Premium プレミアム</h4>
                                <UserMark plan="unlimited" dialog={() => false} />
                            </div>
                            <div className="text-center mb-4">
                                <div className="h2 fw-bold text-warning">$30</div>
                                <small className="text-muted">1か月ごと</small>
                                <div className="h3 fw-bold mt-2">4,000円</div>
                                <small className="text-muted">1か月ごと</small>
                            </div>
                            <div className="mb-3">
                                <Button 
                                    className="w-100 mb-2" 
                                    variant="warning"
                                    onClick={() => checkoutProcessHandler("premium_dollar")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する ($30)
                                </Button>
                                <Button 
                                    className="w-100" 
                                    variant="outline-warning"
                                    onClick={() => checkoutProcessHandler("premium_yen")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する (4,000円)
                                </Button>
                            </div>
                            <PlanConfirmDialog data={{
                                "item_id":"9042b934-09a0-11ef-9428-0242ac130002",
                                "subscription_id": loginInfo.plan === "unlimited" ? officialPlan.subscription_id : "",
                                "name":"プレミアム",
                                "user_name":"アワートAI公式",
                                "amount":4000,
                                "status": loginInfo.plan === "unlimited" ? "ACTIVE" : "",
                                "official":true
                            }} />
                            <div className="mt-auto">
                                <h6 className="fw-bold mb-2">以下のサービスが含まれます</h6>
                                <ul className="list-unstyled small">
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 広告非表示</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 黄色認証マークの表示(要SMS認証)</li>
                                    <li className="mt-2 fw-bold text-muted">画像生成</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 生成回数が最大400枚/直近1日 ※1</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 生成画像のロゴ削除</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> DALL-E3の生成回数が50枚/直近1か月</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> SD3の生成回数が50枚/直近1か月</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> FLUX.1 schnellの生成回数が500枚/直近1か月</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 優先して生成</li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={4} md={6} className="mb-4">
                    <Card className="h-100 border-2" style={{borderColor:"#ddd"}}>
                        <Card.Body className="d-flex flex-column">
                            <div className="text-center mb-3">
                                <h4 className="fw-bold">Premium + プレミアムプラス</h4>
                                <UserMark plan="plus" dialog={() => false} />
                            </div>
                            <div className="text-center mb-4">
                                <div className="h2 fw-bold text-info">$140</div>
                                <small className="text-muted">1か月ごと</small>
                                <div className="h3 fw-bold mt-2">20,000円</div>
                                <small className="text-muted">1か月ごと</small>
                            </div>
                            <div className="mb-3">
                                <Button 
                                    className="w-100 mb-2" 
                                    variant="info"
                                    onClick={() => checkoutProcessHandler("plus_dollar")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する ($140)
                                </Button>
                                <Button 
                                    className="w-100" 
                                    variant="outline-info"
                                    onClick={() => checkoutProcessHandler("plus_yen")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する (20,000円)
                                </Button>
                            </div>
                            <PlanConfirmDialog data={{
                                "item_id":"9042b951-09a0-11ef-9428-0242ac130002",
                                "subscription_id": loginInfo.plan === "plus" ? officialPlan.subscription_id : "",
                                "name":"プレミアムプラス",
                                "user_name":"アワートAI公式",
                                "amount":20000,
                                "status": loginInfo.plan === "plus" ? "ACTIVE" : "",
                                "official":true
                            }} />
                            <div className="mt-auto">
                                <h6 className="fw-bold mb-2">以下のサービスが含まれます</h6>
                                <ul className="list-unstyled small">
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 広告非表示</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 黄色認証マークの表示(要SMS認証)</li>
                                    <li className="mt-2 fw-bold text-muted">画像生成</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 生成回数無制限 ※1</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 生成画像のロゴ削除</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> DALL-E3の生成回数が500枚/直近1か月</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> SD3の生成回数が500枚/直近1か月</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> FLUX.1 schnellの生成回数が5,000枚/直近1か月</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 優先して生成</li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            {/* エコノミープランセクション */}
            <Row className="mb-5 justify-content-center">
                <Col lg={4} md={6} className="mb-4">
                    <Card className="h-100 border-2" style={{borderColor:"#ddd"}}>
                        <Card.Body className="d-flex flex-column">
                            <div className="text-center mb-3">
                                <h4 className="fw-bold">Basic ベーシック</h4>
                                <UserMark plan="basic" dialog={() => false} />
                            </div>
                            <div className="text-center mb-4">
                                <div className="h2 fw-bold text-secondary">$4</div>
                                <small className="text-muted">1か月ごと</small>
                                <div className="h3 fw-bold mt-2">500円</div>
                                <small className="text-muted">1か月ごと</small>
                            </div>
                            <div className="mb-3">
                                <Button 
                                    className="w-100 mb-2" 
                                    variant="secondary"
                                    onClick={() => checkoutProcessHandler("basic_dollar")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する ($4)
                                </Button>
                                <Button 
                                    className="w-100 mb-2" 
                                    variant="outline-secondary"
                                    onClick={() => checkoutProcessHandler("basic_yen")} 
                                    disabled={checkoutProcess}
                                >
                                    {checkoutProcess ? <Spinner animation="border" size="sm" /> : ""} 登録する (500円)
                                </Button>
                                <div className='text-center'>
                                    <MuiButton className='w-100' variant='contained' disabled>コイン未対応</MuiButton>
                                </div>
                            </div>
                            <div className="mt-auto">
                                <h6 className="fw-bold mb-2">以下のサービスが含まれます</h6>
                                <ul className="list-unstyled small">
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 広告非表示</li>
                                    <li className="mt-2 fw-bold text-muted">画像生成</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> ポイントを消費して生成</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 生成画像のロゴ削除</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 生成回数がslowモードで無制限</li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>

                <Col lg={4} md={6} className="mb-4">
                    <Card className="h-100 border-2 border-success">
                        <Card.Body className="d-flex flex-column">
                            <div className="text-center mb-3">
                                <h4 className="fw-bold">Free(アカウント登録)</h4>
                            </div>
                            <div className="text-center mb-4">
                                <div className="h2 fw-bold text-success">$0</div>
                                <small className="text-muted">永年</small>
                            </div>
                            <div className="mb-3">
                                <Button 
                                    className="w-100" 
                                    variant="success"
                                    onClick={() => navigate("/regist-select")}
                                >
                                    アカウント登録する
                                </Button>
                            </div>
                            <div className="mt-auto">
                                <h6 className="fw-bold mb-2">以下のサービスが含まれます</h6>
                                <ul className="list-unstyled small">
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> 青色認証マークの表示(要SMS認証)</li>
                                    <li className="mt-2 fw-bold text-muted">画像生成</li>
                                    <li><Icon.CheckCircleFill className="text-success me-2" /> ポイントを消費して生成</li>
                                </ul>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            {/* 詳細情報セクション */}
            <div className="mb-5">
                <h2 className="text-center mb-4" style={{fontSize:"28px"}}>
                    料金プラン詳細
                </h2>
                <p className="text-center text-muted mb-4">
                    ※口座振り込みは個別にお問い合わせください。
                </p>
                
                <div className="row">
                    <div className="col-lg-6 mb-4">
                        <Card className="h-100">
                            <Card.Header className="bg-primary text-white">
                                <h5 className="mb-0">Standard スタンダード</h5>
                            </Card.Header>
                            <Card.Body>
                                <h6 className="fw-bold mb-3">プラン内容</h6>
                                <ul className="list-unstyled">
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />広告非表示</li>
                                    <li className="mb-2"><Icon.CheckCircleFill style={{color:"#E2B719"}} className="me-2" />黄色認証マークの表示(別途SMS認証を行う必要があります)</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />画像生成の生成回数が最大100枚/直近1日 ※1</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />生成画像のロゴ削除</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />生成履歴の保存期間：7日</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />生成した画像をzipでまとめてダウンロード：一度に最大100枚</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />直近1か月における画像作品の投稿枚数の上限：350枚</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />優先して生成：専用サーバーで処理されるため混雑が緩和されます。</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </div>

                    <div className="col-lg-6 mb-4">
                        <Card className="h-100">
                            <Card.Header className="bg-warning text-dark">
                                <h5 className="mb-0">Premium プレミアム</h5>
                            </Card.Header>
                            <Card.Body>
                                <p className="mb-3 text-muted">ポイントの消費を気にせず利用したい方向けのプランです。</p>
                                <h6 className="fw-bold mb-3">プラン内容</h6>
                                <ul className="list-unstyled">
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />広告非表示</li>
                                    <li className="mb-2"><Icon.CheckCircleFill style={{color:"#E2B719"}} className="me-2" />黄色認証マークの表示(別途SMS認証を行う必要があります)</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />画像生成の生成回数が最大400枚/直近1日 ※1</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />生成画像のロゴ削除</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />DALL-E3の生成回数が直近1か月あたり50枚</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />Stable Diffusion 3、Stable Image Ultraの生成回数が直近1か月あたり50枚</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />FLUX.1 schnellの生成回数が直近1か月あたり500枚</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />生成履歴の保存期間：30日</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />生成した画像をzipでまとめてダウンロード：一度に最大300枚</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />直近1か月における画像作品の投稿枚数の上限：1,000枚</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />優先して生成：専用サーバーで処理されるため混雑が緩和されます。</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </div>

                    <div className="col-lg-6 mb-4">
                        <Card className="h-100">
                            <Card.Header className="bg-info text-white">
                                <h5 className="mb-0">Premium + プレミアムプラス</h5>
                            </Card.Header>
                            <Card.Body>
                                <p className="mb-3 text-muted">ポイントの消費を気にせず利用したい方向けのプランです。</p>
                                <h6 className="fw-bold mb-3">プラン内容</h6>
                                <ul className="list-unstyled">
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />広告非表示</li>
                                    <li className="mb-2"><Icon.CheckCircleFill style={{color:"#E2B719"}} className="me-2" />黄色認証マークの表示(別途SMS認証を行う必要があります)</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />画像生成の生成回数無制限 ※3</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />生成画像のロゴ削除</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />DALL-E3の生成回数が直近1か月あたり500枚</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />Stable Diffusion 3、Stable Image Ultraの生成回数が直近1か月あたり500枚</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />FLUX.1 schnellの生成回数が直近1か月あたり5,000枚</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />生成履歴の保存期間：30日</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />生成した画像をzipでまとめてダウンロード：一度に最大300枚</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />直近1か月における画像作品の投稿枚数の上限：1,000枚</li>
                                    <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />優先して生成：専用サーバーで処理されるため混雑が緩和されます。</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </div>

                    <div className="col-lg-6 mb-4">
                        <Card className="h-100">
                            <Card.Header className="bg-secondary text-white">
                                <h5 className="mb-0">Basic ベーシック / Free(アカウント登録)</h5>
                            </Card.Header>
                            <Card.Body>
                                <div className="mb-4">
                                    <h6 className="fw-bold text-secondary">Basic ベーシック プラン内容</h6>
                                    <ul className="list-unstyled">
                                        <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />広告非表示</li>
                                        <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />画像生成の利用(ポイント消費)</li>
                                        <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />生成画像のロゴ削除</li>
                                    </ul>
                                </div>
                                
                                <div>
                                    <h6 className="fw-bold text-success">Free(アカウント登録) プラン内容</h6>
                                    <p className="small text-muted">アワートAI内でアカウント登録した状態がこれにあたります。</p>
                                    <ul className="list-unstyled">
                                        <li className="mb-2"><Icon.CheckCircleFill style={{color:"#1D9BF0"}} className="me-2" />青色認証マークの表示(要SMS認証)</li>
                                        <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />画像生成の利用(ポイント消費)</li>
                                        <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />生成履歴の保存期間：3日</li>
                                        <li className="mb-2"><Icon.CheckCircleFill className="text-success me-2" />生成した画像をzipでまとめてダウンロード：一度に最大10枚</li>
                                    </ul>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                </div>

                {/* 注意事項 */}
                <Card className="mt-4">
                    <Card.Header className="bg-light">
                        <h5 className="mb-0">注意事項</h5>
                    </Card.Header>
                    <Card.Body>
                        <div className="small">
                            <p><strong>※1</strong> 画像生成の利用回数については、以下の設定のいずれかに当てはまる場合は対象外であり、このプランに入っていてもポイントを消費しますのでご注意ください。またDALL-E3、Stable Diffusion 3(Turbo含む)、Stable Image Ultra、FLUX.1 schnellは対象外です。</p>
                            <ul>
                                <li>stepsが30より大きい</li>
                                <li>SD1.5モデルの解像度が1536x1536、1920x1080、1080x1920</li>
                                <li>SDXLモデルの以下の解像度：2048x2048、1792x2304、1280x2560、2304x1792、2560x1280</li>
                            </ul>
                            
                            <p><strong>※2</strong> 直近24時間あたりの生成枚数です。また、以下は対象外になります。</p>
                            <ul>
                                <li>モデルがDALL-E3、Stable Diffusion 3(Turbo含む)、Stable Image Ultra、FLUX.1 schnell</li>
                                <li>stepsが30より大きい</li>
                            </ul>
                            
                            <p><strong>※3</strong> 画像生成の利用回数無制限については、以下の設定のいずれかに当てはまる場合は対象外であり、このプランに入っていてもポイントを消費しますのでご注意ください。またDALL-E3、Stable Diffusion 3(Turbo含む)、Stable Image Ultra、FLUX.1 schnellは対象外です。</p>
                            <ul>
                                <li>stepsが50より大きい</li>
                            </ul>
                            
                            <p className="mt-3">・生成枚数はベストエフォートであり全ての枚数を使いきれることを保証するものではありません。<br />
                            混雑状況等により上限より少なくなることがあります。また生成数が著しく多い場合は枚数を制限する場合があります。予めご了承ください。</p>
                        </div>
                    </Card.Body>
                </Card>
            </div>

            {/* 特定商取引法 */}
            <div>
                <h3 className="mb-4">特定商取引法に基づく表記</h3>
                <Table striped bordered hover className="mb-5">
                    <tbody>
                        <tr><th style={{width:"25%"}}>運営会社</th><td>アワート合同会社</td></tr>
                        <tr><th>代表者</th><td>元水 稜真</td></tr>
                        <tr><th>所在地</th><td>〒101-0024 東京都千代田区神田和泉町1番地6-16ヤマトビル405</td></tr>
                        <tr><th>電話番号</th><td>090-8835-2738 ※サービスについてのお問い合わせはその他の連絡先から行ってください。</td></tr>
                        <tr><th>その他の連絡先</th><td>
                            <div className="d-flex flex-column">
                                <Link to="https://twitter.com/ourt_ai" className="mb-1">X(旧Twitter)</Link>
                                <Link to="https://discord.gg/646h4vFMv2" className="mb-1">Discord</Link>
                                <Link to="https://lin.ee/9JVODFH" className="mb-1">LINE</Link>
                                <span>メール：contact＠ourt-ai.work</span>
                            </div>
                        </td></tr>
                        <tr><th>料金</th><td>消費税込みの価格で個別に記載。</td></tr>
                        <tr><th>代金の支払い方法</th><td>利用する決済サービスに記載の方法で行う。</td></tr>
                        <tr><th>代金の支払時期</th><td>月額課金制とし、決済を行った日に当月分が請求され、以降は解約しない限り自動的に毎月決済されます。</td></tr>
                        <tr><th>提供時期</th><td>決済後、アワートAI内へプランの反映を行った後に利用可能(3日以内)。</td></tr>
                        <tr><th>返品等についての特約に関する事項</th><td>契約成立後の返品、返金、キャンセルはできません。</td></tr>
                    </tbody>
                </Table>
            </div>
        </Container>
        <Footer />
    </div>
    )
}

export default Legal;
